import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';

import { FuseSharedModule } from '@fuse/shared.module';

import { SubjectListComponent } from './subject-list/subject-list.component';
import { SubjectListItemComponent } from './subject-list/subject-list-item/subject-list-item.component';
import { SubjectListPreviewComponent } from './subject-list-preview/subject-list-preview.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SubjectEditComponent } from './subject-edit/subject-edit.component';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';
import { SubjectCardComponent } from './subject-card/subject-card.component';
import { SubjectMatchComponent } from './subject-match/subject-match.component';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { LabelWidgetsModule } from 'app/main/widgets/label-widgets/label-widgets.module';
import { SubjectSettingsModule } from 'app/shared/subject-settings.module';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { LinkedSubjectsListComponent } from './linked-subjects-list.component';
import { RetentionPromptComponent } from './subject-edit/retention-prompt/retention-prompt.component';

@NgModule({
  declarations: [
    SubjectCardComponent,
    SubjectEditComponent,
    SubjectListComponent,
    SubjectListItemComponent,
    SubjectListPreviewComponent,
    SubjectMatchComponent,
    LinkedSubjectsListComponent,
    RetentionPromptComponent,
  ],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatTableModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatToolbarModule,
    MatMenuModule,
    MatTooltipModule,
    MatDividerModule,
    MatToolbarModule,
    MatDialogModule,
    ScrollingModule,
    FuseSharedModule,
    SubjectSettingsModule,
    GridsterModule,
    PhoenixDirectivesModule,
    LabelWidgetsModule,
    PhoenixPipesModule.forRoot(),
    DynamicModule,
  ],
  providers: [],
  exports: [
    SubjectCardComponent,
    SubjectEditComponent,
    SubjectListComponent,
    SubjectListItemComponent,
    SubjectListPreviewComponent,
    SubjectMatchComponent,
    LinkedSubjectsListComponent,
    RetentionPromptComponent,
  ],
})
export class SubjectComponentsModule {}
